import React from 'react'
import _ from 'lodash/fp'

const MINUTES = 60 * 1000

export const createAutoRefreshableJwtFromLazy = (lazyJwt,intervalInMinutes) => {
  let currentJwt = null

  return () => {
    if (!currentJwt) {
      currentJwt = lazyJwt.read()
      const delayedRefresh = () => {
        setTimeout(() =>
          lazyJwt.use(currentJwt).refresh().promise().then((jwt) => {
            currentJwt = jwt
            delayedRefresh()
          }).catch((e) => {
              if (_.get([0,'status'],e) === 401) {
                alert('Authentication has expired, please open this page again')
              } else {
                delayedRefresh()
              }
          }),
          intervalInMinutes * MINUTES)
      }
      delayedRefresh()
    }
    return currentJwt
  }
}